import moment from "moment";

import { makePaginatedSearch } from "api/makeApiRequestType/makePaginatedSearch";

import { ValidationCallback } from "validation/validate";
import { FollowUpChecksParams } from "validation/getFieldChecker";

import { isValidTime } from "utils/datesAndTimes/isValidTime";

type RawApiOutputRow = {
	id: string;
	dayOfWeekLocaltime: number;
	timeFirstAvailableLocaltime: string;
	timeLastAvailableJustBeforeLocaltime: string;
	timezone: string;
};

const flagValidationErrorsInRow: ValidationCallback<RawApiOutputRow> = (
	input,
	{ flag, checkField }
) => {
	checkField("id", { type: "string" });
	checkField("dayOfWeekLocaltime", { type: "number" });
	checkField("timezone", { type: "string" });

	for (const fieldName of [
		"timeFirstAvailableLocaltime" as "timeFirstAvailableLocaltime",
		"timeLastAvailableJustBeforeLocaltime" as "timeLastAvailableJustBeforeLocaltime"
	]) {
		checkField(fieldName, {
			type: "string",
			isRequired: true,
			followUpChecks: arg => {
				const { findInvalid, value } = arg as FollowUpChecksParams<"string">;
				if (!isValidTime(value as string)) {
					findInvalid("not a valid time");
				} else if (fieldName === "timeFirstAvailableLocaltime") {
					const now = moment.utc();
					if (
						!moment
							.utc(
								`${now.format(`YYYY-MM-DD`)} ${
									input.timeLastAvailableJustBeforeLocaltime
								}`
							)
							.isAfter(`${now.format(`YYYY-MM-DD`)} ${value}`)
					) {
						findInvalid(
							"time-first-available must be before time-last-available"
						);
					}
				}
			}
		});
	}
};

export type OutputRow = Omit<
	RawApiOutputRow,
	"timeFirstAvailableLocaltime" | "timeLastAvailableJustBeforeLocaltime"
> & {
	timeFirstAvailableLocaltime: moment.Duration;
	timeLastAvailableJustBeforeLocaltime: moment.Duration;
};

export const getAvailability = makePaginatedSearch<
	{ uid: string },
	RawApiOutputRow,
	OutputRow
>({
	endPoint: "mentorAvailability",
	flagValidationErrorsInRow,
	postProcessor: (row: RawApiOutputRow) => {
		return {
			...row,
			timeFirstAvailableLocaltime: moment.duration(
				row.timeFirstAvailableLocaltime
			),
			timeLastAvailableJustBeforeLocaltime: moment.duration(
				row.timeLastAvailableJustBeforeLocaltime
			)
		};
	}
});
